import React from "react";
import { Helmet } from "react-helmet";

import { FeatureToggle } from "../../../shared/models/app-data-model";
import useFeatureToggle from "../../hooks/use-feature-toggle/useFeatureToggle";
import { EmbedScriptBlock } from "../../models/app-data-model";

export type EmbedScriptsProps = {
  embedScriptBlocks: EmbedScriptBlock[];
  featureToggles: FeatureToggle[];
  pagePath: string;
};

const EmbeddedScript: React.FC<EmbedScriptsProps> = ({ embedScriptBlocks, featureToggles, pagePath }: EmbedScriptsProps) => {
  const embedScriptsEnabled = useFeatureToggle("embed-scripts", featureToggles);

  return (
    <>
      {embedScriptsEnabled &&
        embedScriptBlocks.map((scriptBlock: EmbedScriptBlock, index) => {
          // function to split the attribute string on the equal sign and create key/value pair
          const attributesAsObj = scriptBlock.embed_information.optional_attributes?.reduce((previous, current) => {
            const [key, value] = current.split("=");
            return { ...previous, [key]: JSON.parse(value) };
          }, {});
          if (scriptBlock.embed_information.enabled) {
            const scriptEmbed = (
              <div key={`embedded-script-${index}`}>
                <Helmet>
                  <script {...attributesAsObj}>{`${scriptBlock.embed_information.script}`}</script>
                </Helmet>
                {scriptBlock.embed_information.div_id && <div id={scriptBlock.embed_information.div_id}></div>}
              </div>
            );

            if (!scriptBlock.embed_information.allow_list && !scriptBlock.embed_information.deny_list) {
              // if allow list and deny list are false serve global embedded script
              return scriptEmbed;
            }
            if (scriptBlock.embed_information.allow_list && scriptBlock.embed_information.deny_list) {
              // if allow list and deny list are both true embedded script was setup incorrectly return null
              return null;
            }

            const currentPageCheck = scriptBlock.embed_information.embedded_page_references.findIndex((o) => o.url === pagePath);
            if (scriptBlock.embed_information.allow_list && currentPageCheck !== -1) {
              // if allow list is true and page path is in page reference list serve embedded script
              return scriptEmbed;
            }
            if (scriptBlock.embed_information.deny_list && currentPageCheck === -1) {
              // if deny list is true and page path is NOT in reference list serve embedded script
              return scriptEmbed;
            }
          }
        })}
    </>
  );
};

export default EmbeddedScript;
